import firebase from "@firebase/app";
import "firebase/firestore";
import "firebase/firebase-auth";
import "firebase/storage";
// import store from "./store";

// Initialize Firebase
var config = {
  apiKey: "AIzaSyDRo-tbY5_SPKKE1qfW9uOVtBf8K3BxsAs",
  authDomain: "posterdayclub.firebaseapp.com",
  databaseURL: "https://posterdayclub.firebaseio.com",
  projectId: "posterdayclub",
  storageBucket: "posterdayclub.appspot.com",
  messagingSenderId: "683638612558",
  appId: "1:683638612558:web:e0742d1bfb39c009",
};

// Get Firestore instance
export const db = firebase.initializeApp(config).firestore();

// export default {
//   install: (Vue, options) => {
//     const firebase = Firebase.initializeApp(config);
//     const auth = firebase.auth();
//     const db = firebase.firestore();
//     Vue.prototype.$auth = {
//       login: async (username, pass) => {
//         return await auth.signInWithEmailAndPassword(username, pass);
//       },
//       logout: async () => {
//         await auth.signOut();
//       },
//     };
//     auth.onAuthStateChanged((user) => {
//       store.commit("updateUser", { user });
//     });
//   },
// };
